import "./faq.scss";
import { useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import coneimg from "../../images/cone.png";

export default function FAQ({ handleCone, affiliate = false }) {
  const [question, setQuestion] = useState(0);
  const [visibleCount, setVisibleCount] = useState(4);

  const handleQuestion = (q) => {
    if (q == question) {
      setQuestion(0);
    } else {
      setQuestion(q);
    }
  };

  const showMore = () => {
    setVisibleCount((prev) => prev + 4);
  };

  return (
    <main className="main__faq" id="faq">
      {/* {!affiliate ? (
        <img
          src={coneimg}
          alt="cone"
          onClick={() => handleCone(4, "cone4")}
          className="cone4"
          id="cone4"
        />
      ) : null} */}
      <h2>FAQ</h2>
      <section className="faq">
        {visibleCount >= 1 && (
          <>
            <strong onClick={() => handleQuestion(17)}>
              What are the times for the Conference days?
              {question == 17 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 17 ? (
              <>
                <p>
                  8:00am - doors open each day for registration (refreshments
                  provided)
                </p>
                <p>9:00am - conference starts each day at 9am prompt</p>
                <p>5:30pm - conference ends each day</p>
                <p>
                  special sessions after conference days end: Monday evening
                  networking - for VIP tickets and above Tuesday evening dinner
                  & after-show party - for Elite tickets and above
                </p>
              </>
            ) : null}
            <hr />

            <strong onClick={() => handleQuestion(1)}>
              I’m an established business owner, is this event for me?{" "}
              {question == 1 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 1 ? (
              <>
                <p>
                  Absolutely! At the Scottish Business Conference, you'll gain
                  invaluable insights into business growth, team building, and
                  scaling to 7 figures and beyond. A key part of the experience
                  is the community — with many Elite and Inner Circle ticket
                  holders being 7-figure business owners, you'll be surrounded
                  by like-minded peers. The connections you make over these
                  three days will be instrumental in driving your business
                  forward.
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(2)}>
              I’m just starting my business, is this event for me?{" "}
              {question == 2 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 2 ? (
              <>
                <p>Yes, definitely!</p>
                <p>
                  This event isn’t just for established business owners. If
                  you're a startup or new to the business world, you'll leave
                  with practical tactics and strategies to help you achieve your
                  first £100K and beyond.
                </p>
              </>
            ) : null}

            <hr />
            <strong onClick={() => handleQuestion(4)}>
              Where can I find the agenda?{" "}
              {question == 4 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 4 ? (
              <>
                <p>
                  The event is dynamic, with many moving parts. Rather than
                  sharing a set agenda that might change, we'll keep you updated
                  on the schedule in real-time during the event.
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(5)}>
              What if I can’t attend all the sessions?{" "}
              {question == 5 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 5 ? (
              <>
                <p>No problem!</p>
                <p>
                  We understand that three days is a big commitment. If you need
                  to step out for calls or meetings, feel free to do so. The
                  venue has great facilities for business needs, and you won’t
                  be expected to be present the entire time.
                </p>
              </>
            ) : null}
            <hr />
          </>
        )}

        {visibleCount >= 5 && (
          <>
            <strong onClick={() => handleQuestion(6)}>
              What’s the difference in ticket levels?{" "}
              {question == 6 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 6 ? (
              <>
                <p>
                  We offer 4 ticket options: General, VIP, Elite & Inner Circle.
                  Click the ‘Secure Your Ticket Now' button on the website for a
                  detailed breakdown of what each level includes.
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(7)}>
              How do I get to the DoubleTree By Hilton Hotel Glasgow?{" "}
              {question == 7 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 7 ? (
              <>
                <p>
                  The DoubleTree by Hilton Hotel Glasgow is centrally located
                  and within walking distance from both Glasgow Central and
                  Queen Street train stations. There is also on-site parking and
                  nearby car parks available. The full address is: 36 Cambridge
                  Street, Glasgow G2 3HN.
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(8)}>
              Can I get recordings if I can’t attend the full event?{" "}
              {question == 8 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 8 ? (
              <>
                <p>Yes!</p>
                <p>
                  Recordings of the full event will be provided for VIP, Elite
                  and Inner Circle ticket holders, free of charge.
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(9)}>
              I can’t attend the event at all—can I still get the recordings?{" "}
              {question == 9 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 9 ? (
              <>
                <p>Unfortunately, no.</p>
                <p>
                  While the recordings are available to ticket holders who
                  attend in person, a key part of the SBC experience is the
                  connect and collaboration opportunities. We encourage you to
                  join us in person to fully benefit from the event.
                </p>
              </>
            ) : null}
            <hr />
          </>
        )}

        {visibleCount >= 9 && (
          <>
            <strong onClick={() => handleQuestion(10)}>
              Will there be networking opportunities during the event?{" "}
              {question == 10 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 10 ? (
              <>
                <p>
                  Absolutely! We don’t call it "networking" because that sounds
                  too formal. Instead, we have ‘Connect and Collaborate’
                  sessions to spark real conversations and genuine connections.
                  Plus, exclusive evening networking for VIP, Elite & Inner
                  Circle ticket holders help these relationships grow naturally.
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(11)}>
              Will I be pitched to for the entire three days?{" "}
              {question == 11 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 11 ? (
              <>
                <p>Definitely not!</p>
                <p>
                  We pride ourselves on providing a valuable, pitch-free
                  environment. SBC is about genuine learning and growth, not
                  hard selling or endless “limited-time offers.” We believe in
                  building businesses with integrity, and that’s exactly what
                  you’ll experience at the event.
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(12)}>
              Will I get the chance to ask questions to headline speakers?{" "}
              {question == 12 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 12 ? (
              <>
                <p>
                  Yes, although we can’t guarantee everyone will get to ask a
                  question due to the size of the audience. However, most
                  headline sessions will include a Q&A segment
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(13)}>
              Do you accommodate attendees with physical limitations?{" "}
              {question == 13 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 13 ? (
              <>
                <p>Absolutely</p>
                <p>
                  Please reach out to us at{" "}
                  <a href="mailto:info@scottishbusinessconference.com">
                    info@scottishbusinessconference.com
                  </a>{" "}
                  with any special accommodations or assistance you require, and
                  we’ll ensure your needs are met.
                </p>
              </>
            ) : null}
            <hr />
          </>
        )}

        {visibleCount >= 14 && (
          <>
            <strong onClick={() => handleQuestion(14)}>
              I want to bring a colleague, but I'm unsure who yet, what should I
              do?{" "}
              {question == 14 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 14 ? (
              <>
                <p>No problem!</p>
                <p>
                  You can register a placeholder name, but each registration
                  needs a unique email. You can transfer the ticket to your
                  colleague later via the link in your confirmation email or by
                  contacting us at{" "}
                  <a href="mailto:info@scottishbusinessconference.com">
                    info@scottishbusinessconference.com
                  </a>
                  .
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(15)}>
              Can I get group discounts?{" "}
              {question == 15 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 15 ? (
              <>
                <p>Yes!</p>
                <p>
                  Group discounts start for parties of 5 or more. Just contact
                  us via WhatsApp or email at{" "}
                  <a href="mailto:info@scottishbusinessconference.com">
                    info@scottishbusinessconference.com
                  </a>{" "}
                  for your exclusive group promo code.
                </p>
              </>
            ) : null}
            <hr />
            <strong onClick={() => handleQuestion(16)}>
              I can’t find my confirmation email—what should I do?{" "}
              {question == 16 ? (
                <KeyboardArrowDownIcon className="faq--icon" />
              ) : (
                <KeyboardArrowRightIcon className="faq--icon" />
              )}
            </strong>
            {question == 16 ? (
              <>
                <p> Don’t worry!</p>
                <p>
                  If you can’t locate your confirmation email, we can easily
                  look you up at registration. For reference, the email will
                  have the subject line ‘Your ticket for SBC 2025!’ and will
                  come from info@scottishbusinessconference.com.
                </p>
              </>
            ) : null}
            <hr />
          </>
        )}
        {visibleCount < 15 && (
          <section className="faq__button">
            <button onClick={showMore} className="faq__see-more">
              See more
            </button>
          </section>
        )}
      </section>
    </main>
  );
}
